import { render, staticRenderFns } from "./CrmDispose.vue?vue&type=template&id=382eec82"
import script from "./CrmDispose.vue?vue&type=script&lang=js"
export * from "./CrmDispose.vue?vue&type=script&lang=js"
import style0 from "./CrmDispose.vue?vue&type=style&index=0&id=382eec82&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports